// extracted by mini-css-extract-plugin
module.exports = {"tooltipTrigger":"_c4538ee5","title":"_5ff4abe8","wrapper":"_f4f64c1b"};